import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./DriverSidebar.css";

const DriverSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  let driver = { name: "Demo Driver" };

  try {
    const stored = sessionStorage.getItem("currentUser");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.role === "driver") driver = { name: parsed.username };
    } else {
      const local = JSON.parse(localStorage.getItem("driver") || "null");
      if (local && local.name) driver = local;
    }
  } catch (e) {}

  return (
    <>
      <button className="driver-hamburger-btn" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      {isOpen && <div className="driver-sidebar-overlay" onClick={() => setIsOpen(false)}></div>}

      <div className={`driver-sidebar ${isOpen ? "open" : ""}`}>

        <div className="driver-top">
          <h5>DRIVER</h5>

          <div className="driver-profile">
            <div className="driver-avatar">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
            </div>
            <p className="driver-name">{driver.name}</p>
          </div>
        </div>

        <ul className="driver-menu">
          <li>
            <NavLink to="/driver/driver-dashboard" onClick={() => setIsOpen(false)}>
              <span className="driver-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5v4.793l2.146 2.147a.5.5 0 0 1-.708.708L8 9.207V4.5A.5.5 0 0 1 8 4z"/>
                  <path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 1a7 7 0 1 1-7 7 7 7 0 0 1 7-7z"/>
                </svg>
              </span> Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink to="/driver/task-assign" onClick={() => setIsOpen(false)}>
              <span className="driver-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z"/>
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3-.5a.5.5 0 0 1-.5-.5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h-2z"/>
                </svg>
              </span> Task Assignment
            </NavLink>
          </li>
        </ul>

      </div>
    </>
  );
};

export default DriverSidebar;